// 차량 상태 필 — theme.STATUS 색(앱 status.dart 와 동일). props: status ('등록완료' … '폐차'), title
import React from 'react';
import { statusColor } from '../theme';
import { pillStyle } from './Pill';

function StatusPill(props) {
  var c = statusColor(props.status);
  return <span className="v2-pill v2-status" data-status={props.status || ''} title={props.title} style={pillStyle(c)}>{props.status || '-'}</span>;
}

export default StatusPill;
